import alt from 'components/Dispatcher';
import ManagerCoachingEffectivenessSource from 'sources/dashboard/ManagerCoachingEffectivenessSource';
import generateAsyncActions from 'utils/generateAsyncActions';

class ManagerCoachingEffectivenessActions {
  constructor() {
    this.generateActions(...generateAsyncActions('getCoachingEffectivenessReport'));
  }
  getCoachingEffectivenessReport(widgetConfig, managerId) {
    return dispatch => {
      dispatch();
      return ManagerCoachingEffectivenessSource.getCoachingEffectivenessReport(
        widgetConfig,
        managerId
      ).then(this.getCoachingEffectivenessReportSuccess, this.getCoachingEffectivenessReportError);
    };
  }
}

export default alt.createActions(ManagerCoachingEffectivenessActions);
